"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _notifyDirectors["default"];
  }
});
var _notifyDirectors = _interopRequireDefault(require("./notifyDirectors"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }